import React, { useState } from 'react';
import { features } from 'configs';
import { useParams } from 'react-router-dom';
import {
  DiagnosisTab,
  AllergiesTab,
  MedicationsTab,
  ExamRequestsTab,
  HospitalizationsTab,
  ProceduresTab,
  EHRTimeline,
} from '..';
import { DiagnosticReportTab } from '../DiagnosticReportTab';
import { DocumentsTimeline } from '../DocumentsTimline';
import './EHRArea.css';
import { EventSummaryTimeline } from '../EventSummaryTimeline';

export function EHRArea({ page = null }) {
  const { pageId } = useParams();
  let initialTab;
  if (!features.myReports) initialTab = 'Summary';
  else if (pageId === 'documentos') initialTab = 'Documents';
  else if (pageId === 'resultadosdeexames') initialTab = 'Results';
  else initialTab = 'EHR';

  const [tabOpen, setTabOpen] = useState(initialTab);

  if (page) {
    return (
      <div>
        {page === 'EHR' && (
          <div className="EHRArea">
            <div className="EHRArea-header">
              <h1 className="pageTitle">Outros registros</h1>
            </div>
            {!features.myReports ? <EHRTimeline /> : <EventSummaryTimeline />}
          </div>
        )}

        {page === 'Results' && (
          <div className="EHRArea">
            <div className="EHRArea-header">
              <h1 className="pageTitle">Resultados de exames</h1>
            </div>
            <DiagnosticReportTab page />
          </div>
        )}
        {page === 'Documents' && (
          <div className="EHRArea">
            <div className="EHRArea-header">
              <h1 className="pageTitle">Atestados, prescrições e Outros</h1>
            </div>
            <DocumentsTimeline page />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="EHRArea">
      <div className="EHRArea-tabs">
        {!features.myReports && (
          <button
            className={tabOpen === 'Summary' && 'EHRArea-openTab'}
            onClick={() => {
              setTabOpen('Summary');
            }}
          >
            Sumário de saúde do paciente
          </button>
        )}

        <button
          className={tabOpen === 'EHR' && 'EHRArea-openTab'}
          onClick={() => {
            setTabOpen('EHR');
          }}
        >
          Registros eletrônicos
        </button>
        <button
          className={tabOpen === 'Results' && 'EHRArea-openTab'}
          onClick={() => {
            setTabOpen('Results');
          }}
        >
          Resultados de exames
        </button>
        <button
          className={tabOpen === 'Documents' && 'EHRArea-openTab'}
          onClick={() => {
            setTabOpen('Documents');
          }}
        >
          Atestados, prescrições e Outros
        </button>
      </div>

      {tabOpen === 'Summary' && (
        <>
          <DiagnosisTab />
          <AllergiesTab />
          <MedicationsTab />
          <ExamRequestsTab />
          <HospitalizationsTab />
          <ProceduresTab />
        </>
      )}

      {tabOpen === 'EHR' && (
        // <EventSummaryTimeline />
        <>{!features.myReports ? <EHRTimeline /> : <EventSummaryTimeline />}</>
      )}

      {tabOpen === 'Results' && (
        <>
          <DiagnosticReportTab />
        </>
      )}
      {tabOpen === 'Documents' && (
        <>
          <DocumentsTimeline />
        </>
      )}
    </div>
  );
}
